import React from "react";
import {
  FormField,
  Link,
  Popover,
  Select,
  SpaceBetween,
} from "@amzn/awsui-components-react";
import { Team } from "models/schemas";

interface SubTeamSelectProps {
  subTeams: Team[];
  selectedSubTeam: string;
  subTeamError: string;
  onSubTeamChange: (value: string) => void;
}

const SubTeamSelect: React.FC<SubTeamSelectProps> = ({
  subTeams,
  selectedSubTeam,
  subTeamError,
  onSubTeamChange,
}) => {
  const selectedOption = selectedSubTeam
    ? {
        value: selectedSubTeam,
        label:
          subTeams.find((t: Team) => t.teamId === selectedSubTeam)
            ?.teamDescription || selectedSubTeam,
      }
    : null;

  return (
    <FormField
      label={
        <SpaceBetween direction="horizontal" size="xs">
          <span>Access group</span>
          <Popover
            header="Access group"
            content="Select the team this access group belongs to."
            dismissButton={true}
            position="bottom"
            size="medium"
            triggerType="custom"
          >
            <Link variant="info">Info</Link>
          </Popover>
        </SpaceBetween>
      }
      errorText={subTeamError}
    >
      <Select
        selectedOption={selectedOption}
        onChange={({ detail }) => {
          onSubTeamChange(detail.selectedOption.value || "");
        }}
        options={subTeams.map((team: Team) => ({
          value: team.teamId,
          label: team.teamDescription,
        }))}
        placeholder="Choose an access group"
        filteringType="auto"
      />
    </FormField>
  );
};

export default SubTeamSelect;
